<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      :expand-config="{ reserve: true }"
      show-footer
      :footer-method="() => footerData"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <OrderGoodsSpecTable
          :orderGoodsCode="row.orderGoodsCode"
          :showDefaultImage="row.isGroup === 'Y'"
          class="m-2"
        />
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:isGroup="{ row }">
        <el-tag size="mini" :type="row.isGroup === 'Y' ? 'light' : 'info'">
          {{ row.v_isGroup }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="$emit('openDetailDialog', row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="'查看图片'"
            placement="top"
          >
            <i
              class="el-icon-picture-outline tool-btn"
              @click="$emit('openImageDialog', row)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import OrderGoodsSpecTable from '../../../order-goods-spec'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  components: { OrderGoodsSpecTable },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      if (!this.tableData) return 0
      let sum = 0
      let qty = 0
      let boxQty = 0
      for (var i = 0; i < this.tableData.length; i++) {
        qty += parseInt(this.tableData[i].qty)
        sum += parseFloat(this.tableData[i].subAmount)
        boxQty += parseFloat(this.tableData[i].boxQty)
      }
      return [
        [
          this.$l('INDEX.total') || '合计',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          qty.toFixed(0),
          '',
          '',
          boxQty.toFixed(0),
          '',
          sum.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
          '',
        ],
      ]
    },
  },
}
</script>
